var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-tabs",
        { attrs: { left: "", color: "transparent" } },
        [_c("v-tab", { attrs: { href: "#tab-1" } }, [_vm._v("Clientes")])],
        1
      ),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c("v-flex", { attrs: { xs12: "", sm6: "", md6: "" } }, [
            _c(
              "div",
              { attrs: { align: "left" } },
              [
                _c("v-text-field", {
                  attrs: {
                    "append-icon": "search",
                    label: "Buscar...",
                    "single-line": "",
                    "hide-details": ""
                  },
                  on: { input: _vm.onFilterTextBoxChanged },
                  model: {
                    value: _vm.search,
                    callback: function($$v) {
                      _vm.search = $$v
                    },
                    expression: "search"
                  }
                })
              ],
              1
            )
          ]),
          _c("v-flex", { attrs: { xs12: "", sm6: "", md6: "" } }, [
            _c(
              "div",
              {
                staticStyle: { "padding-top": "15px" },
                attrs: { align: "right" }
              },
              [
                _vm.accionExportar.visible
                  ? _c(
                      "v-btn",
                      {
                        attrs: { flat: "", small: "", color: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.exportar()
                          }
                        }
                      },
                      [
                        _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                          _vm._v("cloud_download")
                        ]),
                        _vm._v("  \n          "),
                        _c("span", { staticClass: "importExportBtnTexto" }, [
                          _vm._v("Exportar")
                        ])
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("ag-grid-vue", {
            staticClass: "ag-theme-material",
            staticStyle: {
              width: "100%",
              height: "400px",
              "font-family": "'Asap', sans-serif"
            },
            attrs: { gridOptions: _vm.gridOptions }
          })
        ],
        1
      ),
      _c("app-cliente-modal-edicion", {
        attrs: {
          show: _vm.showModalEdit,
          esEdicion: _vm.modalEsEdicion,
          cliente: _vm.editedItem
        },
        on: {
          modalAsociacionEmit: function($event) {
            return _vm.clienteModalCallback($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }